export default __webpack_public_path__ + "static/media/job_3.28c48ec0.png";